import React, { Fragment, useState } from "react"
import { useEffect } from "react";
import MetaTags from 'react-meta-tags';
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { contractDelete, contractDetailResponse, doSign, patchContract, contractWriteResponse } from 'crud/auth.crud';

import { Link, useLocation, useHistory } from "react-router-dom"

import Default from "assets/images/default.png";
import FileUploads from "../../components/RopikCustom/FileUploads";

import loading from "../../assets/images/loading.gif";

import { useSelector } from "react-redux";
import SelectBox from "components/RopikCustom/SelectBox";
import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import Util from "pages/Dashboard/Common/Util";
import FilePreview from "components/RopikCustom/FilePreview";

const ContractManagementDetailScreen = () => {
  const selector = useSelector(state => state)

  const location = useLocation()
  const history = useHistory()

  const [id, setId] = useState(location.state.contract);
  const [myCompany, setMyCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [otherCompany, setOtherCompany] = useState('');
  const [signFile, setSignFile] = useState(selector.auth.user.member_file.filter(item => item.category === 'signFile')?.[0] || null);
  const [otherSignFile, setOtherSignFile] = useState(null);
  const [data, setData] = useState({});
  const [haveAuth, setHaveAuth] = useState(false);
  const [isReceipt, setIsReceipt] = useState(false);
  const [onUpload, setOnUpload] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [contractCompanyGroupId, setContractCompanyGroupId] = useState('')
  const [companyList, setCompanyList] = useState([])
  const [signList, setSignList] = useState([])
  const [edit, setEdit] = useState(false)
  const [previewImages, setPreviewImages] = useState([])
  const [imgArr, setImgArr] = useState([])
  const [inputItem, setInputItem] = useState({})
  const [contractFiles, setContractFiles] = useState([]);

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({...prev, [key]: value}))
  }

  const getData = async () => {
    setOnUpload(true)
    const params = `?contract=${id}`
    const response = await contractDetailResponse(params);

    if (response.data.result === 'success') {
      let tmp = []
      let companyList = []
      for (let i = 0; i < response.data?.data.length; i++) {
        const data = response.data?.data[i];
        let item = {
          id: data.id,
          companyId: data.company,
          companyName: data.contract_company_group_data?.name,
          isSign: data.sign,
          companyType: data.contract_company_group_data.type,
          signFile: data.contract_company_group_data?.company_group?.[0]?.member_group?.member_file?.filter(itm => itm.category === 'signFile')?.[0] || ''
        }
        if (data.company === myCompany) {
          setContractCompanyGroupId(data.id)
        }
        tmp.push(item)
      }
      setCompanyList(companyList)
      setSignList(tmp)
      const contractData = response.data?.data?.[0]?.contract_group_data
      setInputItem({
        subject: contractData.subject,
        createdAt: contractData.created_at?.substr(0, 10),
        startDate: contractData.start_date?.substr(0, 10),
        endDate: contractData.end_date?.substr(0, 10),
        pricePerL: contractData.price_per_l,
        pricePerKg: contractData.price_per_kg,
        minPrice: contractData.min_price,
        content: contractData.content,
        state: contractData.state,
      })
      setContractFiles(contractData.contract_file)
      // 삭제부분에 넣어야함
      if (myCompany === response.data?.data?.[0]?.contract.company && response.data?.data?.[0]?.contract_group_data.state === 'N') {
        setIsEditable(true)
      }
    }
    setOnUpload(false)
  }

  const doDelete = async () => {
    if (!confirm("삭제하시겠습니까?")) {
      return;
    } else {
      setOnUpload(true);
      await contractDelete(id);
      setOnUpload(false);
      alert("정상적으로 삭제되었습니다.");
      history.push("/contract-management-screen");
    }
  }

  const deleteImage = (index) => {    
    setImgArr(imgArr.filter((v, i) => { return i !== index;}))    
    setPreviewImages(previewImages.filter((v, i) => { return i !== index;}))
  }

  const openContract = async () => {
    if (confirm("계약서에 서명하시겠습니까?")) {
      setOnUpload(true)
      const param = {
        id: contractCompanyGroupId,
        contract: id,
        sign: 'Y',
        company: myCompany,
      }
      const response = await doSign(param)
      if (response.status === 200) {
        getData()
      }
    }
  }

  const handleFileChange = (event) => {
    const files = event.target.files;
    let prevTmp = [];
    for (let i = 0; i < files.length; i++) {
      let item = {
        name : files[i].name,
        path :  URL.createObjectURL(files[i]),        
      }
      prevTmp.push(item)
    }
    let tmp = [...imgArr, ...event.target.files];
    tmp = tmp.filter((v, i) => {return i - 5 < 0})    
    setImgArr(tmp)    
    prevTmp = prevTmp.filter((v, i) => {return i - 5 < 0})
    setPreviewImages(prevTmp);
  };

  const editComplete = async () => {
    const fd = new FormData();

    for (let i = 0; i < imgArr.length; i++) {
      let newFile = new File([imgArr[i]], `${encodeURI(imgArr[i].name)}`, {type: imgArr[i].type})
      fd.append('file_' + i, newFile);
    }
    const contractData = {
      id : id
    }
    fd.append('contract_data', JSON.stringify(contractData))

    const response = await patchContract(fd)
    if(response.status === 200){
      getData()
      setEdit(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const otherSignList = signList.filter(itm => itm.companyType === 'emitter' || itm.companyType === 'collection') || []; // 서명란의 회사가 배출자거나 수거운반
  const thisSignList = signList.filter(itm => itm.companyType !== 'emitter' && itm.companyType !== 'collection') || []; // 서명란의 회사가 처리장
  const trCount = Math.ceil(signList.length / 4)
  const signRows = [...Array(trCount).keys()];
  const chunked = Array.from({ length: Math.ceil(signList.length / 4) }, (_, i) =>
    signList.slice(i * 4, i * 4 + 4)
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>계약 상세 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="계약관리" breadcrumbItem="계약 상세" />

          <div className="d-flex align-items-center margin-bottom-12">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 정보</p>
          </div>

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약명</td>
                          <td colSpan="4" className="w-40">
                            {/* {edit ?
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.subject} placeholder="계약명을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('subject', e.target.value)
                            }} />
                            :
                            <>{inputItem.subject}</>
                            } */}
                            {inputItem.subject}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약일자</td>
                          <td className="w-40">{inputItem.createdAt}</td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약기간</td>
                          <td className="w-40">
                            {/* {edit ?
                            <>
                            <input className="waver-input-box w-40 border-radius-0 margin-right-4" type="date" value={inputItem.startDate} onChange={(e) => {
                              changeInputCondition('startDate', e.target.value);
                            }} />
                            <input className="waver-input-box w-40 border-radius-0" type="date" value={inputItem.endDate} onChange={(e) => {
                              changeInputCondition('endDate', e.target.value);
                            }} />
                            </>
                            :
                            <>
                            {inputItem.startDate} ~ {inputItem.endDate}
                            </>
                            } */}
                            {inputItem.startDate} ~ {inputItem.endDate}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">L당 요금</td>
                          <td className="w-40">
                            {/* {edit ?
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.pricePerL} placeholder="L당 요금을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('pricePerL', e.target.value)
                            }} />
                            :
                            <>{inputItem.pricePerL} 원</>
                            } */}
                            {inputItem.pricePerL} 원
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">Kg당 요금</td>
                          <td className="w-40">
                            {/* {edit ?
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.pricePerKg} placeholder="Kg당 요금을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('pricePerKg', e.target.value)
                            }} />
                            :
                            <>{inputItem.pricePerKg} 원</>
                            } */}
                            {inputItem.pricePerKg} 원
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">기본요금</td>
                          <td className="w-40">
                            {/* {edit ?
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.minPrice} placeholder="기본요금을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('minPrice', e.target.value)
                            }} />
                            :
                            <>{inputItem.minPrice} 원</>
                            } */}
                            {inputItem.minPrice} 원
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약여부</td>
                          <td className="w-40" style={{color: inputItem.state == 'Y' ? 'blue' : 'red'}}>
                            {inputItem.state == 'Y' ? "계약완료" : "계약 진행중"}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 내용</td>
                          <td colSpan="4" className="w-40">
                            {/* {edit ?
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="내용을 입력해 주세요" value={inputItem.content}
                              onChange={(e) => {
                                changeInputCondition('content', e.target.value);
                              }} />
                            :
                            <>{inputItem.content}</>
                            } */}
                            {inputItem.content}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 인증</p>
          </div>
          
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        {signRows.map((index) => (
                          <tr key={'sign_row_'+index}>
                            {chunked[index].map((signItem, signIndex) => (
                              <Fragment key={'sign_item_'+index+signIndex}>
                                <td className="w-10 padding-left-8 primary-bg white-text">{signItem.companyName}<br />({signItem.companyType === 'emitter' ? '배출자' : signItem.companyType === 'collection' ? '수거업체' : '처리장'})</td>
                                <td className="w-15" style={{ textAlign: "center", verticalAlign: "middle" }}>
                                  {signItem.isSign === 'N' ?
                                  myCompany === signItem.companyId ?
                                  <button type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none" onClick={() => {
                                    openContract()
                                  }}>
                                    서명하기
                                  </button>
                                  :
                                  <></>
                                  :
                                  <img style={{height: 100}} src={Util.addHostUrl(signItem.signFile?.path)} />
                                  }
                                </td>
                              </Fragment>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약 사본</p>
          </div>
          
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      {edit ?
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약서 첨부</td>
                          <td className="w-90">
                            <input style={{ display: "none" }} type="file" id="getFile" accept="image/*" multiple="multiple" onChange={(e) => {
                              handleFileChange(e)
                            }} />
                            <label htmlFor="getFile" type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none mb-0 text-center">
                              파일 선택 ({previewImages.length} / 5)
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">미리보기</td>
                          <td className="w-90">
                            <FilePreview arr={previewImages} handleDelete={deleteImage} />
                          </td>
                        </tr>
                      </tbody>
                      :
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">
                            계약서 첨부
                          </td>
                          <td className="w-90">
                            <FilePreview arr={contractFiles || []} handleChange={()=>{}} handleDelete={()=>{}} disabled={true}/>
                          </td>
                        </tr>
                      </tbody>
                      }
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: 310 }} className="d-flex justify-content-between margin-bottom-25">
            <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => { history.push('/contract-management-screen') }}>
              목록으로 이동
            </button>
            <div className="d-flex">
              {!edit && data?.['contract_file']?.length === 0 &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                setEdit(true)
              }}>
                수정하기
              </button>
              }
              {edit &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                editComplete()
              }}>
                수정완료
              </button>
              }
              {isEditable &&
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 error-bg white-text button-border" onClick={() => {
                doDelete()
              }}>
                삭제하기
              </button>
              }
            </div>
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
}

export default ContractManagementDetailScreen
